/**
 * @file Manages the pwa storage in local storage
 */

export type PWA = {
  isPWAClicked: boolean;
};

/**
 * Get the current PWA
 */
export function get(): PWA | null {
  const pwa = window.localStorage.getItem('pwa');

  if (pwa) {
    return JSON.parse(pwa);
  }

  return null;
}

/**
 * Set the PWA
 *
 * @param pwa
 */
export function set(pwa: PWA) {
  window.localStorage.setItem('pwa', JSON.stringify(pwa));
}

/**
 * Remove the pwa
 */
export function remove() {
  window.localStorage.removeItem('pwa');
}
